import { AvailabilityMode } from 'actions/AvailabilityActions';
import { LocalDate, LocalDateTime } from 'js-joda';
import { dashboard } from 'types';
import { toJSON } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

export interface SelectedAvailabilityParams {
  ticketTypeId: number[];
  size: number;
  date?: LocalDate;
  tableId?: number[];
  overbookingType?: dashboard.OverbookingType;
  seatingAreaId?: number;
  startDateTime?: LocalDateTime;
}

export interface AvailabilityState {
  calendar?: dashboard.CalendarAvailability;
  selectedParams: SelectedAvailabilityParams;
  requestInProgress: boolean;
  mode: AvailabilityMode;
  selectedPurchaseId?: number;
  showAvailabilityPanel: boolean;
  isAvailabilityDrawerOpen: boolean;
  showAdvancedFilters: boolean;
}

export const initialState: AvailabilityState = {
  calendar: undefined,
  mode: 'DEFAULT',
  requestInProgress: false,
  selectedParams: {
    size: 2,
    ticketTypeId: [],
  },
  showAvailabilityPanel: false,
  isAvailabilityDrawerOpen: false,
  showAdvancedFilters: false,
};

export default function reducer(
  state: AvailabilityState = initialState,
  action: BaseTockAction
): AvailabilityState {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.AVAILABILITY_FETCH_DONE: {
      const json = toJSON<dashboard.CalendarAvailability>(payload);

      return {
        ...state,
        calendar: json,
        requestInProgress: false,
      };
    }
    case AppConstants.AVAILABILITY_FETCH_STARTING: {
      return {
        ...state,
        requestInProgress: true,
      };
    }
    case AppConstants.AVAILABILITY_FETCH_FAILED: {
      return {
        ...state,
        requestInProgress: false,
      };
    }
    case AppConstants.AVAILABILITY_SET_PARAMS: {
      return {
        ...state,
        selectedParams: {
          ...state.selectedParams,
          ...payload,
        },
      };
    }
    case AppConstants.AVAILABILITY_SET_MODE: {
      return {
        ...state,
        mode: payload.mode,
        selectedPurchaseId: payload.selectedPurchaseId,
      };
    }

    case AppConstants.UI_AVAILABILITY_PANEL_SHOW: {
      return {
        ...state,
        showAvailabilityPanel: true,
      };
    }

    case AppConstants.UI_AVAILABILITY_PANEL_HIDE: {
      return {
        ...state,
        showAvailabilityPanel: false,
      };
    }

    case AppConstants.UI_AVAILABILITY_DRAWER_SHOW: {
      return {
        ...state,
        isAvailabilityDrawerOpen: true,
      };
    }

    case AppConstants.UI_AVAILABILITY_DRAWER_HIDE: {
      return {
        ...state,
        isAvailabilityDrawerOpen: false,
      };
    }

    case AppConstants.UI_AVAILABILITY_FILTERS_SHOW: {
      return {
        ...state,
        showAdvancedFilters: true,
      };
    }

    case AppConstants.UI_AVAILABILITY_FILTERS_HIDE: {
      return {
        ...state,
        showAdvancedFilters: false,
      };
    }

    case AppConstants.UI_AVAILABILITY_CLEAR_PARAMS: {
      return {
        ...state,
        selectedParams: initialState.selectedParams,
      };
    }

    default:
      return state;
  }
}
